(() => {
  if (window.baesicBodyFilterReady) return;
  window.baesicBodyFilterReady = true;
  const clean = value => value.normalize('NFKC').replace(/[\u2010-\u2015]/g, '-').replace(/\s+/g, ' ').trim();
  const types = value => value.split(/[;|\n]/).map(clean).filter(Boolean);
  const key = value => value.toLocaleLowerCase();
  const arrange = root => {
    const grid = root.querySelector('.collection-list');
    const cards = [...grid.querySelectorAll(':scope > .chassis-card')];
    const visible = cards.filter(card => !card.hidden);
    const columns = parseInt(getComputedStyle(grid).getPropertyValue('--nav-columns'), 10) || 1;
    cards.forEach(card => card.style.gridColumn = 'auto / span 2');
    const remainder = visible.length % columns;
    if (remainder) visible[visible.length - remainder].style.gridColumn = (columns - remainder + 1) + ' / span 2';
  };
  const apply = root => {
    const filter = root.querySelector('[data-body-filter]');
    const value = filter.querySelector('select').value;
    const cards = [...root.querySelectorAll('.chassis-card[data-body-type]')];
    cards.forEach(card => card.hidden = !!value && !types(card.dataset.bodyType).some(type => key(type) === value));
    const visible = cards.filter(card => !card.hidden).length;
    filter.querySelector('[data-body-reset]').disabled = !value;
    filter.querySelector('[data-body-status]').textContent = visible + ' / ' + cards.length;
    root.querySelector('[data-body-empty]').hidden = visible > 0;
    arrange(root);
    document.dispatchEvent(new CustomEvent('baesic:vehicle-ratios'));
  };
  const initialize = () => document.querySelectorAll('[data-body-filter]').forEach(filter => {
    if (filter.dataset.ready) return;
    const root = filter.closest('.shopify-section');
    const select = filter.querySelector('select');
    const options = new Map();
    root.querySelectorAll('.chassis-card[data-body-type]').forEach(card => types(card.dataset.bodyType).forEach(type => {
      if (!options.has(key(type))) options.set(key(type), type);
    }));
    [...options].sort((a,b) => a[1].localeCompare(b[1])).forEach(([value,label]) => select.add(new Option(label,value)));
    filter.dataset.ready = 'true';
    filter.hidden = false;
    select.addEventListener('change', () => apply(root));
    filter.querySelector('[data-body-reset]').addEventListener('click', () => { select.value = ''; apply(root); select.focus(); });
    apply(root);
  });
  window.addEventListener('resize', () => document.querySelectorAll('[data-body-filter][data-ready]').forEach(filter => arrange(filter.closest('.shopify-section'))), {passive:true});
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
